<template>
  <div class="row recommend-event-news-item-container">
    <div class="recommend-event-news-item-left" :class="{'negative-count': data.sentiment==='负面'}">
      <div class="count">{{data.heat}}</div>
      <img v-if="showIcon" src="../../assets/img/hot.svg" class="lightning-img" alt="">
    </div>
    <div class="recommend-event-news-item-right">
      <router-link target="_blank" :to="{path: '/event-detail', query:{title: data.title, id: data.eventId}}">
        <div class="recommend-event-news-item-right-title-content">{{data.title}}</div>
      </router-link>
      <div class="recommend-event-news-item-companies">
        <div class="row" v-for="(item, index) in data.companies" :key="index">
          <div class="recommend-event-news-item-company" @click="toCompanyDetail(item.name)">{{item.stock_code}}</div>
          <RecommendEventPopover :item="item"></RecommendEventPopover>
          <div></div>
        </div>
      </div>
      <div class="row recommend-event-news-item-right-bottom">
        <div>{{data.count}}条相关新闻</div>
        <div class="recommend-event-news-item-right-first-time">首篇报道: {{data.firstTime}}</div>
        <div>最新报道: {{data.lastTime}}</div>
      </div>
    </div>     
  </div>
</template>

<script>
import RecommendEventPopover from '@/components/recommend/RecommendEventPopover';

export default {
  name: 'recommend-event-news-item',
  props: {
    data: {
      type: Object
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  components: {
    RecommendEventPopover
  },
  methods: {
    toEventDetailPage() {
      const routeUrl = this.$router.resolve({
        path: '/event-detail', 
        query: {
          title: this.data.title,
          id: this.data.eventId
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.recommend-event-news-item-container {
  padding: 10px 16px;
  background-color: #ffffff;
  .recommend-event-news-item-left {
    height: 100%;
    width: 45px;
    color: #ff5b65;
    font-size: 14px;
    text-align: center;
    .count:after {
      content: "\00b0"
    }
    .lightning-img {
      margin-right: 5px;
      width: 16px;
    }
  }
  .negative-count {
    color: #36c292;
  }
  .recommend-event-news-item-right {
    margin-left: 4px;
    width: 100%;
    height: 100%;
    .recommend-event-news-item-right-title-content {
      display: inline-block;
      margin-bottom: 8px;
      color: #171f46;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .recommend-event-news-item-companies {
      .recommend-event-news-item-company {
        margin: 0 8px 8px 0;
        padding: 0 8px;
        border-radius: 2px;
        border: solid 1px rgba(69, 168, 204, 0.4);
        color: rgba(69, 168, 204, 0.8);
        font-size: 14px;
        cursor: pointer;
        &:hover {
          border: 1px solid #45a8cc;
          color: #45a8cc;
        }
      }
    }
    .recommend-event-news-item-right-bottom {
      color: #747990;
      font-size: 12px;
      .recommend-event-news-item-right-first-time {
        margin: 0 10px;
      }
    }
  }
}
</style>

